import React from 'react';
import { VStack } from '@chakra-ui/react';
import { useTokens } from '../../../context/TokenProvider';
export const PAGE_CONTENT_PADDING_X = '60px';
const PageContent = ({ children, ...rest }) => {
    const tokens = useTokens();
    return (React.createElement(VStack, { align: "start", px: PAGE_CONTENT_PADDING_X, pt: "50px", minH: "100vh", pb: "160px", bgColor: tokens.Layer03, ...rest }, children));
};
export default PageContent;
